module.exports = __webpack_public_path__ + "img/L3Harris_Technologies-Logo 2.d928ab3b.svg";